import { useState } from "react";

import { useScrollTop } from "@wojtekmaj/react-hooks";
import clsx from "clsx";

import { headerMenu } from "../../datasets/headerMenu";
import { LinkButton } from "../../views/components/LinkButton";

import { NavMobile } from "./NavMobile";

import { specialColorSchemes } from "../../datasets/headerColors";

import Menu from "../../assets/svg/header/Menu.svg";
import DemystLogo from "../../assets/svg/DemystLogo.svg";
import { Banner } from "./Banner";

import Link from "next/link";
import usePathChange from "../../../utils/hooks/usePathChange";
import { useUser } from "../../../redux/Provider";

export const Header = ({ showBanner = true, showNav = true }) => {
  const pathname = usePathChange();
  const scrollTop = useScrollTop();
  const user = useUser();
  const isUserLoggedIn = user && !!user.user;
  const [mobileNavOpen, changeMobileNavOpen] = useState(false);

  const isLanding = !showNav;

  const isScrolledTop = scrollTop === 0;

  const specialColorScheme = specialColorSchemes.find(({ path, directory }) => {
    if (path) return path === pathname;
    if (!path && directory) return pathname.startsWith(`/${directory}/`);

    return false;
  });

  const headerBackground = isScrolledTop && specialColorScheme?.background;
  const logo = isScrolledTop && specialColorScheme?.logo;
  const menu = isScrolledTop && specialColorScheme?.menu;

  return (
    <>
      <header className={clsx("layout-header-full", isLanding && "layout-header-full-landing")}>
        {showBanner && <Banner />}
        <div
          className={clsx(
            "layout-header-full-header",
            !isLanding && headerBackground,
            isLanding && specialColorScheme?.background,
            isScrolledTop && "on-top",
          )}
        >
          <section className="section-layout">
            <section className="layout-header-main">
              <Link href={"/"} className="layout-header-logo" title="Return home">
                <img
                  src={!isLanding ? logo?.src || DemystLogo.src : specialColorScheme?.logo.src}
                  className="layout-header-logo-img"
                  alt="Demyst"
                  loading="eager"
                  height="40"
                  width="162"
                />
              </Link>
              {!isLanding && isUserLoggedIn && (
                <section className="layout-header-buttons">
                  <LinkButton
                    variant="primary"
                    href={headerMenu.platform_button_target}
                    autoWidth
                    size="md"
                  >
                    {headerMenu.platform_button}
                  </LinkButton>
                </section>
              )}
              {!isLanding && (
                <button className="layout-header-menu" onClick={() => changeMobileNavOpen(true)}>
                  <img
                    src={menu?.src || Menu.src}
                    alt="Menu"
                    height="18"
                    width="24"
                    title="Click to open menu"
                    loading="eager"
                  />
                </button>
              )}
              {mobileNavOpen && (
                <NavMobile isUserLoggedIn={isUserLoggedIn} closeMenu={changeMobileNavOpen} />
              )}
            </section>
          </section>
        </div>
      </header>
    </>
  );
};
